<template>
  <vue-easy-print ref="easyPrint">
    <slot></slot>
  </vue-easy-print>
</template>

<script>
  import vueEasyPrint from 'vue-easy-print';
  export default {
    components: {
      vueEasyPrint,
    },
    data() {
      return {};
    },
    props: {},
    computed: {},

    /**页面必要代码Start */
    mounted() {
      // 分页html
      window.onload = function () {
        var _iframe = document
          .getElementById('easyPrintIframe')
          .contentWindow.document.getElementsByTagName('html');
        _iframe[0].style.overflow = 'initial'; //修改样式
      };
    },

    methods: {
      print() {
        this.$refs.easyPrint.print();
      },
    },
  };
</script>
